import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbNav, NgbNavOutlet, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileHeaderComponent } from 'src/app/common/profile-header/profile-header.component';
import { SwooshComponent } from 'src/app/common/ui-elements/swoosh.component';
import { AppService } from '../../app.service';
import { TeamProfileBlindSpotsComponent } from './blind-spots/team-profile-blind-spots.component';
import { TeamProfileCharacteristicsComponent } from './characteristics/team-profile-characteristics.component';
import { TeamProfileStrengthsComponent } from './strengths/team-profile-strengths.component';

@Component({
  selector: 'app-team-profile',
  templateUrl: './team-profile.component.html',
  styleUrls: ['./team-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SwooshComponent,
    ProfileHeaderComponent,
    TeamProfileCharacteristicsComponent,
    TeamProfileStrengthsComponent,
    TeamProfileBlindSpotsComponent,
    NgbNavModule,
    NgbNav,
    NgbNavOutlet,
  ],
})
export class TeamProfileComponent implements OnInit {
  swooshText = '';
  swooshExternal = '';
  teamMbtiType: string;
  isMobileLayout: boolean;

  constructor(private appService: AppService) {
    this.isMobileLayout = window.innerWidth < 768;
  }

  ngOnInit() {
    this.teamMbtiType = this.appService.getTeamInfo().teamMbtiType;
    window.onresize = () => (this.isMobileLayout = window.innerWidth < 768);

    if (this.appService.getTeamInfo().isElevateTeam) {
      this.swooshText = 'Back to Your Elevate Dashboard';
      this.swooshExternal = this.appService.getTeamInfo().redirectUrl;
    }
  }
}
